import { FUNNEL_JOURNEY_ANALYTICS_READ } from '../scopeTypes';

// @ts-expect-error untyped import
import { useHasScopes } from './useHasScope';
export const useHasFunnelJourneyAccess = () => useHasScopes(FUNNEL_JOURNEY_ANALYTICS_READ);